"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInvestorForm = void 0;
var LoginState_1 = require("@/pages/common/states/LoginState");
exports.defaultInvestorForm = {
    firstname: '',
    lastname: '',
    fullname: '',
    company: '',
    salutation: LoginState_1.Salutation.NONE,
    email: '',
    phone: '',
    comment: '',
};
